// ตัวจัดรูปแบบตัวเลข/เวลา ใช้ร่วมกันทุกหน้า (ย้ายมาจาก js/app.js)
export const fmtInt = (n: unknown) => Math.round(Number(n) || 0).toLocaleString("th-TH");

export const fmtBaht = (n: unknown) => "฿" + Math.round(Number(n) || 0).toLocaleString("th-TH");

/** ย่อเลขใหญ่ให้อ่านเร็ว — 1.2K / 3.4M (ตัวเลขเต็มอ่านไม่ทันบนการ์ด KPI) */
export const fmtCompact = (n: unknown) => {
  const v = Number(n) || 0;
  if (v >= 1e6) return (v / 1e6).toFixed(v >= 1e7 ? 0 : 1) + "M";
  if (v >= 1e3) return (v / 1e3).toFixed(v >= 1e4 ? 0 : 1) + "K";
  return String(Math.round(v));
};

/** เวลาตอบ: ต่ำกว่าชั่วโมงบอกเป็นนาที เกินวันบอกเป็นวัน — ตัวเลขดิบเป็น ms อ่านไม่รู้เรื่อง */
export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null) return "—";
  const m = ms / 60000;
  if (m < 1) return "< 1 นาที";
  if (m < 60) return Math.round(m) + " นาที";
  const h = m / 60;
  if (h < 24) return (h < 10 ? h.toFixed(1) : Math.round(h)) + " ชม.";
  return (h / 24).toFixed(1) + " วัน";
}

/** "3 ชม.ที่แล้ว" — ใช้กับเวลาข้อความล่าสุดของห้องแชท */
export function timeAgo(t: string | number | null | undefined): string {
  if (t == null) return "";
  const ms = Date.now() - new Date(t).getTime();
  if (!isFinite(ms)) return "";
  const m = ms / 60000;
  if (m < 1) return "เมื่อครู่";
  if (m < 60) return Math.round(m) + " นาทีที่แล้ว";
  const h = m / 60;
  if (h < 24) return Math.round(h) + " ชม.ที่แล้ว";
  return Math.round(h / 24) + " วันที่แล้ว";
}

export const pctText = (v: number | null | undefined) =>
  v == null ? "—" : Math.round(v * 100) + "%";
